import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const addextraFiled = ( form_id,state,) => {
  return axios.post(API + "company/Addextafiled/", {
    form_id,
    state
  },{headers: authHeader(),});
};
const AddExtraFiledService = {
    addextraFiled,
  };
  export default AddExtraFiledService;